import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export default function Login() {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="h-screen bg-[#0d1117] flex items-center justify-center">
      <div className="text-center space-y-6">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-[#e6edf3]">Tutor Agent</h1>
          <p className="text-[#8b949e] text-sm">Sign in to access your AI marking assistant</p>
        </div>
        <button
          onClick={() => loginWithRedirect()}
          className="px-6 py-2.5 bg-[#238636] hover:bg-[#2ea043] text-white text-sm font-medium rounded-md transition-colors"
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
